import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { UserRole } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'userRolesDisplay',
  pure: true,
})
export class UserRolesDisplayPipe implements PipeTransform {
  transform(value: UserRole): string {
    return CoreNiceLabelUtils.userRoles(value);
  }
}
